import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19137b69"
import script from "./grnMatch.js?vue&type=script&lang=js&external"
export * from "./grnMatch.js?vue&type=script&lang=js&external"
import style0 from "./grnMatch.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports